import { render } from "./Vouchers.vue?vue&type=template&id=ebfe58ea"
import script from "./Vouchers.vue?vue&type=script&lang=ts"
export * from "./Vouchers.vue?vue&type=script&lang=ts"
script.render = render

export default script